module.exports = __webpack_public_path__ + "static/media/plan-C2b-desktop-en.4982b6bc.png";